import { Haptics, ImpactStyle } from "@capacitor/haptics";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar";

// Extend dayjs with plugins
dayjs.extend(relativeTime);
dayjs.extend(calendar);

export const extractQuestions = (content: string): string[] => {
  const matches = content.match(/<question>(.*?)<\/question>/g);
  if (!matches) return [];
  return matches.map((match) => {
    const question = match.replace(/<question>|<\/question>/g, "").trim();
    return question;
  });
};

export const ScanningPlaybook = [
  "In the huddle...",
  "Scanning the playbook...",
  "Drawing up the perfect play...",
  "Crunching the numbers...",
  "Watching film on your opponent...",
  "Reading the defense...",
  "Breaking down the tape...",
  "Calling an audible...",
  "Running some plays...",
  "Analyzing formations...",
  "Checking matchups...",
  "Reading coverage...",
  "Loading game script...",
  "Dialing up a blitz..."
];


export const skeletonWidths = [
  "80%",
  "95%",
  "95%",
  "60%",
  "65%",
  "70%",
  "50%",
  "30%",
];

export const hapticsImpactLight = async () => {
  await Haptics.impact({ style: ImpactStyle.Light });
};

export const getTextSize = (length: number): string => {
  if (length === 0) return "text-[24px]"; // Default size for empty/placeholder
  if (length < 50) return "text-[24px]"; // Normal size for short text
  if (length < 100) return "text-[20px]"; // Medium size
  if (length < 200) return "text-[16px]"; // Smaller size
  if (length < 500) return "text-[14px]"; // Even smaller
  return "text-[12px]"; // Minimum size for very long text
};

// Function to format timestamps in a user-friendly way
export const formatDateTime = (timestamp: string) => {
  if (!timestamp) return "";
  
  const date = dayjs(timestamp);
  const now = dayjs();
  const yesterday = now.subtract(1, 'day');
  
  // Function to get ordinal suffix (st, nd, rd, th)
  const getOrdinalSuffix = (day: number) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };
  
  // Format day with ordinal suffix
  const formatDayWithOrdinal = (dateObj: dayjs.Dayjs) => {
    const day = dateObj.date();
    return `${day}${getOrdinalSuffix(day)}`;
  };
  
  // If date is today
  if (date.format('YYYY-MM-DD') === now.format('YYYY-MM-DD')) {
    return `Today, ${date.format('h:mm a')}`;
  }
  
  // If date is yesterday
  if (date.format('YYYY-MM-DD') === yesterday.format('YYYY-MM-DD')) {
    return `Yesterday, ${date.format('h:mm a')}`;
  }
  
  // If date is within the current year
  if (date.format('YYYY') === now.format('YYYY')) {
    const month = date.format('MMMM');
    const day = formatDayWithOrdinal(date);
    return `${month} ${day}, ${date.format('h:mm a')}`;
  }
  
  // If date is from a previous year
  const month = date.format('MMMM');
  const day = formatDayWithOrdinal(date);
  return `${month} ${day}, ${date.format('YYYY, h:mm a')}`;
};
